import * as React from 'react'
import { INotification } from '../../common/notifications/NotificationReducers'
import Notification from './Notification'

export interface INotificationsProps {
  notification: INotification | null
}

class Notifications extends React.PureComponent<INotificationsProps> {
  render() {
    const { notification } = this.props

    return notification && <Notification {...notification}>{notification.content}</Notification>
  }
}

export default Notifications
